import React from "react";
import { Color, Flex, Text } from "src/elements";
import styled from "styled-components";
import { textVariants } from "../Text/store/variants";
import { styledSafe } from "src/utils/styledComponent";

const TextareaContainer = styled(Flex)<{ height?: string }>`
  position: relative;
  width: 100%;
  height: ${({ height }) => height};
`;

const TextareaTitle = styled(Flex)`
  position: absolute;
  top: -11px;
  left: 8px;
  background-color: ${Color.white};
  padding: 0 3px;
`;

const TextareaElement = styledSafe("textarea")<{ height?: string; minHeight?: string }>`
  width: 100%;
  height: ${({ height }) => height};
  min-height: ${({ minHeight }) => minHeight};
  border: 1px solid ${Color.primary};
  border-radius: 4px;
  padding: 10px;
  font-size: ${textVariants.body3.fontSize};
  line-height: ${textVariants.body3.lineHeight};
  font-weight: ${textVariants.body3.fontWeight};
  resize: none;
  outline: none;

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-track {
    background: ${Color.white};
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: ${Color.primary};
    border-radius: 10px;
  }
`;

interface Props {
  title: string;
  value: string;
  setValue?: (value: string) => void;
  height?: string;
  minHeight?: string;
  className?: string;
}

export const Textarea: React.FC<Props> = ({
  title,
  value,
  height,
  minHeight,
  className,
  setValue,
}) => {
  return (
    <TextareaContainer height={height}>
      <TextareaTitle>
        <Text variant="small1" color={Color.primary}>
          {title}
        </Text>
      </TextareaTitle>

      <TextareaElement
        height={height}
        minHeight={minHeight}
        value={value}
        className={className}
        readOnly={setValue === undefined}
        onChange={(value) => {
          if (setValue) {
            setValue(value.currentTarget.value);
          }
        }}
      />
    </TextareaContainer>
  );
};
